import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AdminInHouseStores from "../components/Admin/AdminInHouseStores";

const AdminInHouseStoresPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <div className="flex pt-20">
        {/* Sidebar - Fixed positioning for better responsiveness */}
        <div className="hidden 800px:block w-[310px] fixed left-0 top-20 h-full z-10">
          <AdminSideBar active={28} />
        </div>

        {/* Main Content */}
        <div className="flex-1 800px:ml-[310px]">
          <AdminInHouseStores />
        </div>
      </div>
    </div>
  );
};

export default AdminInHouseStoresPage;
